import { useNavigate } from 'react-router-dom'

import FormularioIngreso from '../components/ingresos/FormularioIngreso'
import ModalMensaje from '../components/ui/ModalMensaje'
import { useEmpresa } from '../context/EmpresaContext'
import { useModalMensaje } from '../hooks/useModalMensaje'
import { supabase } from '../lib/supabase'

function NuevoIngreso() {
  const navigate = useNavigate()
  const { empresaActual } = useEmpresa()
  const { modal, abrirModal, cerrarModal } = useModalMensaje()

  const guardarIngreso = async (datosFormulario) => {
    const nuevoIngreso = {
      ...datosFormulario,
      empresa_id: empresaActual.id,
      estado_registro: 'registrado',
    }

    const { error } = await supabase
      .from('ingresos')
      .insert(nuevoIngreso)

    if (error) {
      throw error
    }

    abrirModal({
      tipo: 'success',
      titulo: 'Ingreso registrado',
      mensaje: 'El ingreso fue registrado correctamente.',
      onAceptar: () => {
        cerrarModal()
        navigate('/ingresos', { state: { recargar: true } })
      },
    })
  }

  return (
    <>
      <FormularioIngreso
        modo="crear"
        onGuardar={guardarIngreso}
        onCancelar={() => navigate('/ingresos')}
      />

      <ModalMensaje {...modal} />
    </>
  )
}

export default NuevoIngreso
